<template>
  <el-row class="register-protocol-container">
    <el-col :span="24">
      <el-card class="box-card">
        <div slot="header" class="clearfix flex justify-between">
          <span>注册协议</span>
        </div>
        <el-form label-position="right" label-width="120px">
          <el-form-item :label="$t('registerProtocol.userProtocol')">
            <div class="editor-container">
              <RichTextEditor ref="userEditor" v-model="registerProtocolInfo.userProtocol" />
            </div>
          </el-form-item>

          <el-form-item :label="$t('registerProtocol.merchantProtocol')">
            <div class="editor-container">
              <RichTextEditor ref="merchantEditor" v-model="registerProtocolInfo.merchantProtocol" />
            </div>
          </el-form-item>

          <el-form-item>
            <el-button
              type="primary"
              class="float-right"
              @click="updateRegisterProtocol"
            >
              {{ $t('common.modify') }}
            </el-button>
          </el-form-item>
        </el-form>
      </el-card>
    </el-col>
  </el-row>
</template>

<script>
import { getRegisterProtocolList, updateRegisterProtocol } from '@/api/frame/registerProtocol/registerProtocolApi'
import RichTextEditor from '@/components/system/RichTextEditor.vue'

export default {
  name: 'RegisterProtocol',
  components: {
    RichTextEditor
  },
  data() {
    return {
      loaded: false,
      registerProtocolInfo: {
        userProtocol: '',
        merchantProtocol: '',
        protolcolId: ''
      }
    }
  },
  created() {
    this.getRegisterProtocols()
  },
  methods: {
    async getRegisterProtocols() {
      try {
        const res = await getRegisterProtocolList({ page: 1, row: 1 })
        if (res.data && res.data.length > 0) {
          this.registerProtocolInfo = { ...res.data[0] }
          this.$nextTick(() => {
            if (this.$refs.userEditor) {
              this.$refs.userEditor.setContent(this.registerProtocolInfo.userProtocol || '')
            }
            if (this.$refs.merchantEditor) {
              this.$refs.merchantEditor.setContent(this.registerProtocolInfo.merchantProtocol || '')
            }
          })
        }
        this.loaded = true
      } catch (error) {
        console.error('获取注册协议失败:', error)
        this.loaded = true
      }
    },
    async updateRegisterProtocol() {
      try {
        const res = await updateRegisterProtocol(this.registerProtocolInfo)
        if (res.code === 0) {
          this.$message.success(this.$t('common.submitSuccess'))
          this.getRegisterProtocols()
        } else {
          this.$message.error(res.msg)
        }
      } catch (error) {
        console.error('更新注册协议失败:', error)
        this.$message.error(this.$t('common.submitFailed'))
      }
    }
  }
}
</script>

<style scoped>
.register-protocol-container {
  width: 100%;
}
.editor-container {
  margin-bottom: 20px;
}
.float-right {
  float: right;
}
</style>
